const phone = '(min-width: 0px)';
const phoneMax = '(max-width: 600px)';
const desktop = '(min-width: 981px)';

export { desktop, phone, phoneMax };
